import { render, staticRenderFns } from "./PeopleCountDashboardItem.vue?vue&type=template&id=17cedbbe&scoped=true"
import script from "./PeopleCountDashboardItem.vue?vue&type=script&lang=js"
export * from "./PeopleCountDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./PeopleCountDashboardItem.vue?vue&type=style&index=0&id=17cedbbe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cedbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cedbbe')) {
      api.createRecord('17cedbbe', component.options)
    } else {
      api.reload('17cedbbe', component.options)
    }
    module.hot.accept("./PeopleCountDashboardItem.vue?vue&type=template&id=17cedbbe&scoped=true", function () {
      api.rerender('17cedbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/PeopleCountDashboardItem.vue"
export default component.exports